module.exports = __webpack_public_path__ + "img/D202201_3.4bc00363.jpg";